import { render, staticRenderFns } from "./devProtManagement.vue?vue&type=template&id=f132f810&"
import script from "./devProtManagement.vue?vue&type=script&lang=js&"
export * from "./devProtManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports